import React from 'react';

const AlreadyCompletedErrorModalBody = () => {
  return <div>Form already completed</div>;
};

export default AlreadyCompletedErrorModalBody;
